import React, { useState, useRef, useEffect } from 'react';
import axios from "axios";
import EditMediaPopup from "../Components/EditMediaPopup"
import { DataTableList } from '../Components/DataTable/DataTable';
import { formattedDate, formatFileSize } from "../utils/functions"

import filePdfIcon from "../images/file-pdf-icon.svg";
import fileDocIcon from ".././images/file-doc-icon.svg";
import fileDocxIcon from ".././images/file-docx-icon.svg";
import filePptIcon from ".././images/file-ppt-icon.svg";
import filePptmIcon from ".././images/file-pptm-icon.svg";
import filePptxIcon from ".././images/file-pptx-icon.svg";
import fileXlsIcon from ".././images/file-xls-icon.svg";
import fileXlsmIcon from ".././images/file-xlsm-icon.svg";
import fileXlsxIcon from ".././images/file-xlsx-icon.svg";
import fileVideoIcon from ".././images/file-video-icon.svg";
import fileAudioIcon from ".././images/file-audio-icon.svg";
import downloadIcon from '.././images/download.svg'
import clear from '.././images/delete.svg'
import edit from '.././images/pen.svg'
import more from '../images/more.svg';
import close from '../images/Settings/close.svg'


const ListLayout = ({ userMedia, setUserMedia, setUploadNewmedia, uploadNewmedia, selectedItems, setSelectedItems, toggleCleared, isLoading, setShowUpgradeModel, paymentMethods, setSaveNotify, isLoadingData, setIsLoadingData }) => {
    const ref = useRef();
    const maxSizeInBytes = 128 * 1024 * 1024;
    const [showPopup, setShowPopup] = useState(false);
    const [showUpgradeBtn, setShowUpgradeBtn] = useState(false);
    const [editedItemId, setEditedItemId] = useState(null);

    const [openPopupIndex, setOpenPopupIndex] = useState(null);

    const [deleteMeida, setDeleteMedia] = useState(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [isDelLoading, setDelIsLoading] = useState(false);
    const [isDownLoading, setIsDownLoading] = useState(false);
    const [downloadLink, setDownloadLink] = useState('');
    const [isImageDragging, setIsImageDragging] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [errorMessages, setErrorMessages] = useState([])
    const [fileList, setFileList] = useState({ '^image/': 'Images' });
    const [columnWidths, setColumnWidths] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);

    const mediaIconSet = {
        'application/pdf': filePdfIcon,
        'application/doc': fileDocIcon,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': fileDocxIcon,
        'application/vnd.ms-powerpoint': filePptIcon,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': filePptxIcon,
        'application/vnd.ms-powerpoint.presentation.macroenabled.12': filePptmIcon,
        'application/vnd.ms-excel': fileXlsIcon,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': fileXlsxIcon,
        'application/vnd.ms-excel.sheet.macroenabled.12': fileXlsmIcon,
        'video/mp4': fileVideoIcon,
        'video/mpeg': fileVideoIcon,
        'video/ogg': fileVideoIcon,
        'video/webm': fileVideoIcon,
        'video/3gpp': fileVideoIcon,
        'video/3gpp2': fileVideoIcon,
        'video/x-msvideo': fileVideoIcon,
        'video/quicktime': fileVideoIcon,
        'audio/aac': fileAudioIcon,
        'audio/midi': fileAudioIcon,
        'audio/mpeg': fileAudioIcon,
        'audio/ogg': fileAudioIcon,
        'audio/wav': fileAudioIcon,
        'audio/webm': fileAudioIcon,
        'audio/3gpp': fileAudioIcon,
    }
    const allowFIleType = {
        '^image/': 'Images',
        '^video/': 'Videos',
        'application/pdf': 'PDF',
        'application/doc': 'DOC',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
        'application/vnd.ms-powerpoint': 'PPT',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'PPTM',
        'application/vnd.ms-excel': 'XLS',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
        'application/vnd.ms-excel.sheet.macroenabled.12': 'XLSM'
    }
    const togglePopup = (index) => {
        if (index === openPopupIndex) {
            setOpenPopupIndex(null);
        } else {
            setOpenPopupIndex(index);
        }
    };

    const handleEditClick = (itemId) => {
        setShowPopup(true)
        setEditedItemId(itemId);
    };


    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target) && e.target.closest('.dropdown') === null ) {
                setOpenPopupIndex(null); 
            }
        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, []);

    useEffect(() => {
        if(deleteConfirmation) {
            const checkIfClickedOutside = (e) => {
                if (e.target != null && deleteConfirmation && (e.target.classList.contains('mediaModalOverlay'))) {
                    setDeleteConfirmation(false);
                }
            };
            document.addEventListener("mousedown", checkIfClickedOutside);
        
            return () => {
                document.removeEventListener("mousedown", checkIfClickedOutside);
            };
        }
    }, [deleteConfirmation]);
    useEffect(() => {

        if( paymentMethods?.plan !== 'free_plan' ) {
            setFileList({
                '^image/' : 'Images', 
                '^video/': 'Videos', 
                'application/pdf': 'PDF', 
                'application/doc': 'DOC', 
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX', 
                'application/vnd.ms-powerpoint': 'PPT', 
                'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX', 
                'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'PPTM', 
                'application/vnd.ms-excel': 'XLS', 
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX', 
                'application/vnd.ms-excel.sheet.macroenabled.12': 'XLSM'
            })
        } else {
            setFileList({
                '^image/': 'Images',
            })
        }

        
    }, [paymentMethods]);
    

    const handleDeleteButton = async () => {
        try{
            setDelIsLoading(true);            
            await axios.delete( `${process.env.REACT_APP_API_URL}/user/deleteMedia/${deleteMeida}`);

            const updatedData = userMedia.filter(media => media._id !== deleteMeida);
            setUserMedia(updatedData);

            setDelIsLoading(false);
            setDeleteConfirmation(false);
            setShowPopup(false);
            setDeleteMedia(null);
        } catch (error) {
            setDelIsLoading(false);
            console.log(error)
        }
    }
    const handleDownloadButton = async (itemId) => {
        if( isDownLoading == false ) {
            try {
                setIsDownLoading(true);
                let downloadUrl = downloadLink;

                if( downloadLink === '' ) {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_URL}/user/getDownloadLink/${JSON.parse(localStorage.getItem("userinfo"))?._id}?mediaId=${itemId}`,
                    )
    
                    if(response.status === 200) {                        
                        downloadUrl = response.data.downloadLink;
                        setDownloadLink(response.data.downloadLink);
                    }
                }
                
                if( downloadUrl ) {        
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', itemId.object_id); // specify the filename you want to save as
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
    
                setIsDownLoading(false);
    
            } catch (error) {
                setIsDownLoading(false);
                console.error('Error while trying to download the file:', error);
            }
        }
    }
    const handleGalleryImageDrop = async (e) => {
        e.preventDefault();
        let newErrorMessages = [];
        setErrorMessages([]);
        setShowUpgradeBtn(false);
        setIsImageDragging(false);
        const files = e.dataTransfer.files;

        for (const file of files) {
            const isAllowedFileType = Object.keys(fileList).some((pattern) => new RegExp(pattern).test(file.type));

            if (!isAllowedFileType) {
                const errorMessage = 'This file type is not supported';
                newErrorMessages.push(errorMessage);

                if( Object.keys(allowFIleType).some((pattern) => new RegExp(pattern).test(file.type)) ) {
                    setShowUpgradeBtn(true);
                }
                continue; // Skip this file
            }

            if (file.size > maxSizeInBytes) {
                console.log(`File ${file.name} exceeds the maximum size of 128MB.`);
                continue; // Skip this file
            }

            setErrorMessages(newErrorMessages)

            const formData = new FormData();
            formData.append('files', file); // Append each file individually

            const uploadMedia = {
                _id: Math.floor(Math.random() * (999999999999999 - 111111111111111 + 1)) + 111111111111111,
                name: file.name,
                description: '',
                alt: file.name,
                type: file.type,
                size: file.size,
                object_id: "",
                key: "",
                url: "",
                createdAt: "",
                isLoading: true
            }

            setUserMedia((prevUserMedia) => [uploadMedia, ...prevUserMedia]);

            try {
                const res = await axios.post(
                    `${process.env.REACT_APP_API_URL}/user/uploadMedia/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
                    formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                );
                // Update the uploadMedia object with the response data
                setUserMedia((prevUserMedia) =>
                    prevUserMedia.map((media) =>
                        media._id === uploadMedia._id ? { ...media, ...res.data.result[0], isLoading: false } : media
                    )
                );
            } catch (error) {
                console.log(error);
            }
        }

        setIsImageDragging(false);
        setErrorMessages(newErrorMessages);
    };

    const handleFileDragOver = (e) => {
        e.preventDefault();
        if (!isDragging) {
            setIsImageDragging(true);
        }
    }

    const handleFileDragLeave = (e) => {
        e.preventDefault();
        setIsImageDragging(false);
    };

    const customTitleSort = (rowA, rowB) => {
        const titleA = rowA?.name.toString().toLowerCase();
        const titleB = rowB?.name.toString().toLowerCase();

        // Natural sort comparison for mixed numbers and letters
        return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
    };

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = userMedia?.reduce((acc, row) => {
                // Calculate width for 'Type' column based on (row.object_id).split('.')[1].toUpperCase()
                const typeValue = (row?.object_id).split('.')[1]?.toUpperCase();
                const typeLength = typeValue?.length;
                if (!acc['object_id'] || typeLength > acc['object_id']) {
                    acc['object_id'] = typeLength + 2;
                }
        
                // Calculate width for 'Size' column based on formatFileSize(row.size)
                const sizeValue = formatFileSize(row.size);
                const sizeLength = sizeValue?.length;
                if (!acc['size'] || sizeLength > acc['size']) {
                    acc['size'] = sizeLength - 2;
                }

                const nameValue = row.name;
                const nameLength = nameValue?.length;
                if (!acc['name'] || nameLength > acc['name']) {
                    acc['name'] = nameLength;
                }
                return acc;
            }, {});
        
            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                if(key === 'size'){
                        acc[key] = `${tempWidths[key] * 10 + 70}px`;
                    } else if(key === 'object_id'){
                        acc[key] = `${tempWidths[key] * 10 + 55}px`;
                    } else if(key === 'name'){
                        acc[key] = `${tempWidths[key] * 10 + 60}px`;
                    } else {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    }
                return acc;
                }, {});
        
                setColumnWidths(widthMap); // Set the calculated column widths
            }
            resolve(); // Resolve the promise once widths are set
        });
    };

    const columns = [
        {
            name: 'File',
            selector: (row) => row?.name,
            cell: (row) => {
                return (
                    <div className={`picture-main ${row?.isLoading ? 'loading-row' : ''}`}>
                        <div className={`file-picture ${(row?.type).includes('image') ? 'type-image' : 'type-doc'}`}>
                            <img src={mediaIconSet[row?.type] ? mediaIconSet[row?.type] : row?.url} onClick={() => handleEditClick(row?._id)} alt={row?.name} className='item' />
                        </div>
                        <div className='file-data-wrapper' >
                            <div className='file-name' onClick={() => handleEditClick(row?._id)}>
                                {row?.name}
                            </div>
                        </div>
                    </div>
                )
            },
            sortable: true,
            minWidth: columnWidths['name'] && (parseInt(columnWidths['name']) + 50 > 300) ? '300px' : `${parseInt(columnWidths['name']) + 50}px`,  
            sortFunction: customTitleSort,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Type',
            selector: (row) => (row?.object_id).split('.')[1]?.toUpperCase(), // Ensure this returns the status value
            width: '100px',
            style: { width: '100px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Size',
            selector: (row) => formatFileSize(row?.size),
            paddingLeft: 0,
            sortable: true,
            width: columnWidths['size'] || '200px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", width: columnWidths['size'] || '200px', fontSize: "14px" },
        },
        {
            name: 'Upload Date',
            selector: row => formattedDate(row?.createdAt),
            sortable: true,
            paddingLeft: 0,
            width: '150px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", minWidth: '150px', fontSize: "14px" },
        },
        {
            name: 'Last Updated',
            selector: (row) => formattedDate(row?.updatedAt),
            sortable: true,
            paddingLeft: 0,
            width: '120px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", width: '120px', fontSize: "14px" },
        },
        {
            name: 'Actions',
            cell: (row) => (
                <>
                    <div className='pagesTableAction publicationAction' onClick={() => togglePopup(row)} ref={ref}>
                        <img src={more} alt="More" />
                    </div>
                    {(openPopupIndex?._id === row?._id) &&
                <div className='dropdown addDropdown dropdown-field' >
                    <ul>
                        <li>
                            <a href="#" onClick={(e) => { e.preventDefault(); handleEditClick(row?._id); setOpenPopupIndex(null); }}> <img src={edit} alt="Icon" /> Edit </a>
                        </li>
                        <li>
                            <a href="#" onClick={(e) => { e.preventDefault(); handleDownloadButton(row?._id); setOpenPopupIndex(null); }}> <img src={downloadIcon} alt="Icon" /> Download </a>
                        </li>
                        <li>
                            <a href="#" onClick={(e) => { e.preventDefault(); setDeleteConfirmation(true); setDeleteMedia(row?._id) }}> <img src={clear} alt="Icon" /> Delete </a>
                        </li>
                    </ul>
                </div>
            }
                </>
            ),
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            width: '80px',
            paddingRight: '16px',
            style: { textAlign: 'right', width: '80px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" }, // Aligning to the right
            headerStyle: { textAlign: 'right' },
        },
    ];
    useEffect(() => {
        if (userMedia.length > 0) {
            calculateColumnWidths();
        } 
    }, [userMedia]);

    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);  
        }
    }, [columnWidths]);

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedItems([])
        } else {

            const allIds = userMedia.map((row) => row._id);
            setSelectedItems(allIds); // Select all items
        }
        setIsAllSelected(!isAllSelected); // Toggle master checkbox
    };
    
    return (
        <div className={`${isImageDragging ? "draging media-list" : "pagesTableWrapper media-list"}`} onDragOver={handleFileDragOver}
            onDragLeave={handleFileDragLeave}
            onDrop={handleGalleryImageDrop}>
            <div className={`pagesTable dataTable-list ${(isLoadingData) ? 'loading-list' : ''}`}>
                <DataTableList
                    columns={columns}
                    data={userMedia}
                    onSelectedRowsChange={({ selectedRows }) => {
                        const selectedIds = selectedRows.map((row) => row._id);
                        setSelectedItems(selectedIds)
                        setIsAllSelected(selectedIds.length === userMedia.length);
                    }}
                    progressPending={isLoading}
                    progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    customStyles={customStyles}
                    selectableRowsComponent="input"
                    selectAllRows={isAllSelected}
                    onSelectAllChange={handleMasterCheckboxChange}
                    type="media-gallery"
                    name="Media Library"
                    status="all"
                    selectableRows={true}
                    clearSelectedRows={toggleCleared}
                    onclickhandle={() => setUploadNewmedia(!uploadNewmedia)} 
                />

            </div>
            {showPopup &&
                <EditMediaPopup setShowPopup={setShowPopup} item={userMedia.find(item => item._id === editedItemId)} userMedia={userMedia} setUserMedia={setUserMedia} setSaveNotify={setSaveNotify} />
            }
            {deleteConfirmation &&
                <>
                    <div className="welcomeOverlay mediaModalOverlay"></div>
                    <div className='welcomeModal mediaDeleteModal'>
                        <div className="popupTop popupTopClose closePlan">
                            <img src={close} onClick={e => { setDeleteConfirmation(false) }} alt="Icon" />
                        </div>
                        <h3 className='popupTitle'>Delete Media</h3>
                        <p className='popupDesc'>Are you sure you want to delete this media? This action cannot be undone.</p>

                        <div className="btnGroupLink btnGroupWidth">
                            <button className="secondary-button button" type="button" onClick={() => setDeleteConfirmation(false)}>Cancel</button>
                            <button className="primary-button button" type="button" onClick={() => {handleDeleteButton()}} >
                                {isDelLoading ?
                                    <div className="settingPage-loader">
                                        <div className="ring-loader"></div>
                                    </div>
                                    : "Delete"
                                }
                            </button>
                        </div>
                    </div>
                </>
            }
            {/*errorMessages && errorMessages.length > 0 && (
                <div className="errorMessages">
                    {errorMessages.map((errorMessage, index) => (
                        <>
                            <p key={index} className="error-message" >{errorMessage}</p>
                            {showUpgradeBtn && <p className='upgrade-message' onClick={handleUpgrade}>Upgrade Now</p>} 
                        </>
                    ))}
                </div>
            )*/}
        </div>
    );
};

export default ListLayout;